import angular from 'angular'
import component from './distributor.component'

export default angular
  .module('ellipsis.distributor', [])
  .component('distributor', component)
